<template lang="html">
  <div class="wardrobe-container" v-if="wardrobeLoaded">
    <AddWardrobeProductModal />
    <div class="wardrobe-header">
      <div><h1 class="page-title">Wardrobe</h1></div>
      <div class="button-group">
        <create-wardrobe-outfit-button />
        <add-wardrobe-product-button />
      </div>
    </div>

    <div class="mb-5">
      <hr style="margin-bottom: -1px" />
      <wardrobe-nav />
    </div>

    <transition name="slide-fade" mode="in-out">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
// BUTTONS
import AddWardrobeProductButton from "@/components/wardrobe/buttons/AddWardrobeProductButton";
import CreateWardrobeOutfitButton from "@/components/wardrobe/buttons/CreateWardrobeOutfitButton";

// MODALS
import AddWardrobeProductModal from "@/components/wardrobe/AddWardrobeProductModal";

// UI
import WardrobeNav from "@/components/wardrobe/WardrobeNav";

// MISC
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    AddWardrobeProductButton,
    AddWardrobeProductModal,
    CreateWardrobeOutfitButton,
    WardrobeNav,
  },

  created() {
    if (
      !this.wardrobeDataStates.wardrobe.fetching &&
      !this.wardrobeDataStates.wardrobe.loaded
    ) {
      this.fetchCurrentWardrobe({ wardrobeId: this.currentUser.wardrobe_id });
    }
  },

  beforeDestroy() {
    this.resetWardrobeDataStates();
    this.setWardrobeProductIdsPending([]);
  },

  computed: {
    ...mapGetters(["currentUser", "wardrobeDataStates"]),

    wardrobeLoaded() {
      return this.wardrobeDataStates.wardrobe.loaded;
    },
  },

  methods: {
    ...mapActions([
      "fetchCurrentWardrobe",
      "resetWardrobeDataStates",
      "setWardrobeProductIdsPending",
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.wardrobe-container {
  .wardrobe-header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include for-tablet-portrait-up {
      flex-direction: row;
    }

    .page-title {
      margin-bottom: 30px;

      @include for-tablet-portrait-up {
        margin-bottom: 50px;
      }
    }
  }

  .button-group {
    display: flex;
    flex-direction: row;
    justify-content: start;

    div:not(:last-child) {
      margin-right: 15px;
    }

    @include for-tablet-portrait-up {
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Users/Wardrobe.vue